export const faqs = [
  {
    q: "投稿需要实名吗？会不会暴露我的身份？",
    a: "不需要实名。投稿时你可以只填写昵称，我们只在编辑部内部保留一个可联系的邮箱，用于核实细节。除非你主动要求署名，否则公开页面不会出现你的个人信息。",
  },
  {
    q: "什么样的线索更容易被采用？",
    a: "带有明确时间、地点或完整过程描述的线索采用率最高。相比一张孤立截图，我们更看重能说明来龙去脉的素材，例如连续几天的记录、完整的沟通过程或多位来源的交叉印证。",
  },
  {
    q: "投稿之后大概多久能看到整理结果？",
    a: "一般 24 小时内会完成初筛，信息完整的线索平均 4.2 小时即进入整理流程。如果涉及需要多方求证的内容，可能会延长到 1 至 3 个工作日，我们会在原条目上标注「跟进中」。",
  },
  {
    q: "我看到的内容与事实不符，可以申请修正吗？",
    a: "可以。请通过编辑部邮箱提交说明，附上可以核对的信息来源。我们会在核实后对原文进行更正，并在条目末尾保留修改记录，保证过程透明。",
  },
  {
    q: "平台会公开投稿人的原始联系方式吗？",
    a: "不会。所有联系方式仅用于编辑部内部核实，不会出现在任何公开页面，也不会提供给第三方。事件热度过去后，我们仍会保留加密存档以便后续申诉核查。",
  },
  {
    q: "为什么有些条目只写了「网友投稿」没有更多细节？",
    a: "当线索仍在核实阶段、或涉及需要保护的信息时，我们会先以简讯形式放出并标注状态，等确认后再补充细节。这样既能及时呈现，也避免传播不完整的信息。",
  },
];